export const environment = {
  production: true,
  url: `${location.origin}`,
};
